import * as React from 'react';
import { Text } from '../Text';
import { PICKER_DATA_HOOKS, PICKER_DATA_PROPS } from './dataHooks';
import { ChevronLeft, ChevronRight } from '@wix/wix-ui-icons-common/on-stage';
import { IconButton } from '../IconButton';
import { st, classes } from './Picker.st.css';
import type { PickerProps } from './types';

const Picker: React.FunctionComponent<PickerProps> = (props) => {
  const {
    onPrev,
    value,
    onNext,
    prevDisabled,
    nextDisabled,
    prevAriaLabel,
    nextAriaLabel,
    className,
  } = props;

  const getDataAttributes = () => {
    return {
      [PICKER_DATA_PROPS.NextDisabled]: nextDisabled,
      [PICKER_DATA_PROPS.PrevDisabled]: prevDisabled,
    };
  };

  return (
    <div
      data-hook={props['data-hook']}
      className={st(classes.root, {}, className)}
      {...getDataAttributes()}
    >
      <IconButton
        className={classes.arrow}
        icon={<ChevronLeft />}
        onClick={() => (prevDisabled ? null : onPrev())}
        disabled={prevDisabled}
        data-hook={PICKER_DATA_HOOKS.Prev}
        title={PICKER_DATA_HOOKS.Prev}
        aria-label={prevAriaLabel}
      />
      <Text role="status" className={classes.value}>
        {value}
      </Text>
      <IconButton
        className={classes.arrow}
        icon={<ChevronRight />}
        onClick={() => (nextDisabled ? null : onNext())}
        disabled={nextDisabled}
        data-hook={PICKER_DATA_HOOKS.Next}
        title={PICKER_DATA_HOOKS.Next}
        aria-label={nextAriaLabel}
      />
    </div>
  );
};

Picker.defaultProps = {
  prevDisabled: false,
  nextDisabled: false,
  prevAriaLabel: '',
  nextAriaLabel: '',
};

export { Picker };
